export default __webpack_public_path__ + "static/media/002-bomb-1.2d43aba2.png";